// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once the new-action modal is an sp app.
export const NEW_ACTION_MODAL_SUCCESS = "new-action-modal:success";

/** Announces the record a new-action modal created, as a bubbling event from its trigger with the record as `detail`. */
export function announceNewActionSuccess(trigger, record) {
  trigger.dispatchEvent(new CustomEvent(NEW_ACTION_MODAL_SUCCESS, { bubbles: true, detail: record }));
}
